import { FailedRowBulkResponse } from '../model/referral/referral';

export const formatBulkErrorMessage = (failedCount: number, errors: FailedRowBulkResponse[], successCount?: number): JSX.Element => (
    <div>
        {successCount != null && successCount > 0 && (
            <p style={{ margin: '0 0 4px' }}>{successCount} {successCount === 1 ? 'row' : 'rows'} successfully uploaded.</p>
        )}
        <strong>{failedCount} {failedCount === 1 ? 'row' : 'rows'} failed to upload.</strong>
        <ul style={{ margin: '6px 0 0', paddingLeft: '16px' }}>
            {errors.map((e) => (
                <li key={e.rowNumber}>Row {e.rowNumber}: {e.error}</li>
            ))}
        </ul>
    </div>
);
